module.exports = __webpack_public_path__ + "img/newsImg3-14.6f29f662.png";